var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "200px",
    width: "200px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7ecf4"
    },
    d: "M406.261,133.565c-0.304,0-0.609,0-0.924,0.006C397.01,58.538,333.217,0,256,0 S114.99,58.538,106.663,133.571c-0.315-0.006-0.62-0.006-0.924-0.006c-55.239,0-100.174,44.94-100.174,100.174 S50.5,333.913,105.739,333.913h300.522c55.239,0,100.174-44.94,100.174-100.174S461.5,133.565,406.261,133.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bac7"
    },
    d: "M406.261,333.913c55.239,0,100.174-44.94,100.174-100.174S461.5,133.565,406.261,133.565 c-0.304,0-0.609,0-0.924,0.006C397.01,58.538,333.217,0,256,0v333.913H406.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M189.293,163.859c-0.26,0-0.522-0.006-0.782-0.017c-9.206-0.424-16.326-8.239-15.902-17.446 c2.055-44.646,38.685-79.614,83.391-79.614c9.217,0,16.696,7.473,16.696,16.696s-7.479,16.696-16.696,16.696 c-26.827,0-48.805,20.979-50.044,47.755C205.544,156.88,198.163,163.859,189.293,163.859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2bac7"
    },
    d: "M167.63,366.631c-6.521-6.521-17.087-6.521-23.609,0l-44.522,44.522 c-6.521,6.516-6.521,17.092,0,23.609c6.521,6.521,17.087,6.521,23.609,0l16.022-16.022v76.565c0,9.223,7.479,16.696,16.696,16.696 s16.696-7.473,16.696-16.696v-76.565l16.022,16.022c6.522,6.522,17.086,6.522,23.609,0c6.521-6.516,6.521-17.092,0-23.609 L167.63,366.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e7ecf4"
    },
    d: "M388.892,438.979L372.87,455v-71c0-9.223-7.479-16.696-16.696-16.696 c-9.217,0-16.696,7.473-16.696,16.696v71l-16.022-16.022c-6.521-6.521-17.087-6.521-23.609,0c-6.521,6.516-6.521,17.092,0,23.609 l44.522,44.522c3.261,3.261,7.533,4.892,11.804,4.892s8.544-1.631,11.804-4.892l44.522-44.522c6.521-6.516,6.521-17.092,0-23.609 C405.978,432.456,395.413,432.456,388.892,438.979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6F2FF"
    },
    d: "M272.696,83.478c0-9.223-7.479-16.696-16.696-16.696v33.391 C265.217,100.174,272.696,92.701,272.696,83.478z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.2797f474251ce19021ecf097ca051e88.svg";
export { ForwardRef as ReactComponent };